import "./style.css";
import "./share-dialog.css";
import {EXTERNAL_NAME} from "@meltwater/mi-manifest-client/build/external-name";

class SharableDashboardBuilderComponent {
  requestInProgress = false;
  $rootScope: any;
  $scope: any;
  $emelent: any;
  config: {
    displayName: any;
    password: any;
    id: any; //uuid assigned server side,
    dashboardId: any;
    title: any;
    companyId: any;
    created: any;
    modified: any;
  };
  $timeout: any;
  $window: any;
  $location: any;
  $http: any;
  $mdMedia: any;
  $mdDialog: any;
  $mdMenu: any;
  $mdToast: any;
  stateService: any;
  mwEnvDetector: any;
  Upload: any;
  CoreUserService: any;
  SHARABLE_DASHBOARD_URL: any;
  NEW_SHARABLE_DASHBOARD_URL: any;
  FAIRHAIR_WEB_URL: any;
  ANALYZE_WEB_URL: any;
  SHARABLE_DASHBOARDS_LIMIT: any;
  SHARABLE_DASHBOARDS_PREMIUM_LIMIT: any;
  $translate: any;
  creatingReportFlag: boolean;
  toastMessage: any;
  company: any;
  isDirty: boolean;
  buttonTooltip: any;
  dragControlListeners: {
    accept: (sourceItemHandleScope: any, destSortableScope: any) => boolean;
    itemMoved: (event: any) => void;
    orderChanged: (event: any) => void;
  };
  isInitialShare: any;
  generateContent: any;
  sharedReportsCount: any;
  dashboardId: any;
  showLoading: boolean;
  widgets: any;
  link: string;
  origPassword: any;
  password: any;
  dashboardName: any;
  showCopySuccess: boolean;
  companyId: string;
  isProd = false;

  constructor(
    $rootScope,
    $scope,
    $element,
    $timeout,
    $window,
    $location,
    $http,
    $mdMedia,
    $mdDialog,
    $mdMenu,
    $mdToast,
    stateService,
    mwEnvDetector,
    Upload,
    CoreUserService,
    CoreCompanyService,
    SHARABLE_DASHBOARD_URL,
    NEW_SHARABLE_DASHBOARD_URL,
    FAIRHAIR_WEB_URL,
    ANALYZE_WEB_URL,
    SHARABLE_DASHBOARDS_LIMIT,
    SHARABLE_DASHBOARDS_PREMIUM_LIMIT,
    $translate
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$emelent = $element;
    this.$timeout = $timeout;
    this.$window = $window;
    this.$location = $location;
    this.$http = $http;
    this.$mdMedia = $mdMedia;
    this.$mdDialog = $mdDialog;
    this.$mdMenu = $mdMenu;
    this.$mdToast = $mdToast;
    this.stateService = stateService;
    this.mwEnvDetector = mwEnvDetector;
    this.Upload = Upload;
    this.CoreUserService = CoreUserService;
    this.SHARABLE_DASHBOARD_URL = SHARABLE_DASHBOARD_URL;
    this.NEW_SHARABLE_DASHBOARD_URL = NEW_SHARABLE_DASHBOARD_URL;
    this.FAIRHAIR_WEB_URL = FAIRHAIR_WEB_URL;
    this.ANALYZE_WEB_URL = ANALYZE_WEB_URL;
    this.SHARABLE_DASHBOARDS_LIMIT = SHARABLE_DASHBOARDS_LIMIT;
    this.SHARABLE_DASHBOARDS_PREMIUM_LIMIT = SHARABLE_DASHBOARDS_PREMIUM_LIMIT;
    this.$translate = $translate;
    this.creatingReportFlag = false;

    this.toastMessage = null;
    this.company = null;
    this.isDirty = false;

    this.buttonTooltip = null;

    this.config = {
      id: null, //uuid assigned server side,
      dashboardId: null,
      title: null,
      companyId: null,
      created: null,
      modified: null,
    };

    this.CoreUserService.getCurrent(true).then(
      function (user) {
        this.user = user;
      }.bind(this)
    );

    CoreCompanyService.getCurrent(true).then(
      function (company) {
        this.company = company;
        if (
          this.config.companyId === undefined ||
          this.config.companyId === null ||
          this.config.companyId.length === 0
        ) {
          this.config.companyId = this.company._id;
        }
      }.bind(this)
    );

    this.dragControlListeners = {
      accept: function (sourceItemHandleScope, destSortableScope) {
        return true;
      },
      itemMoved: function (event) {},
      orderChanged: function (event) {},
      // containment: '#board'//optional param.
      // clone: true //optional param for clone feature.
      // allowDuplicates: false //optional param allows duplicates to be dropped.
    };

    this.$mdDialog.show({
      controller: () => this,
      controllerAs: "$ctrl",
      templateUrl: "shareDashboardDialogTemplate",
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      fullscreen: true,
    });
  }

  $onInit() {
    this.isProd = window.location.hostname.indexOf(".com") !== -1;
    this.isInitialShare = this.generateContent;
    //Check premium entitlements on delay if needed to give time for entitlements to load
    if (this.stateService.entitlements.length > 0) {
      this.checkShareEntitlements()
    } else {
      //Manually load entitlements if they are not available when this controller is loaded
      const manifestClient: any = window[EXTERNAL_NAME];
      if (!manifestClient) {
        throw new Error(
          "Could not find Manifest Client"
        );
      }
      let currentManifestEnvironment;
      if (this.isProd) {
        currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
      } else {
        currentManifestEnvironment = manifestClient.Environments.STAGING;
      }

      manifestClient.Initializer.initialize(currentManifestEnvironment);
      manifestClient.ManifestClient.getInstance()
        .then(maniInstance => maniInstance.getCurrentManifest())
        .then(mani => {
          this.stateService.entitlements = mani.entitlements.v6;
          this.checkShareEntitlements()
        })
    }
    this.config.dashboardId = this.dashboardId;
  }

  $doCheck(obj) {}

  $onDestroy() {
    if (this.toastMessage) {
      this.$mdToast.hide(this.toastMessage);
    }
  }

  checkShareEntitlements() {
    var limit = this.SHARABLE_DASHBOARDS_LIMIT;
    if (
      this.stateService.entitlements["sharable-dashboards-premium"] !== undefined &&
      this.stateService.entitlements["sharable-dashboards-premium"] !== null &&
      this.stateService.entitlements["sharable-dashboards-premium"].value === true
    ) {
      limit = this.SHARABLE_DASHBOARDS_PREMIUM_LIMIT;
    }
    if (this.sharedReportsCount >= limit && this.generateContent) {
      this.$window.location.href =
        this.NEW_SHARABLE_DASHBOARD_URL + "/sharable-dashboard-manager/true";
    }
  }

  generate() {
    this.generateContent = true;
  }

  showReport() {
    this.showLoading = false;

    this.$timeout(function () {
      // After animations are done, reflow all the charts so that they honor the width they're supposed to have in the builder
      // This isn't a problem for viewing the final report
      if (Highcharts !== undefined && Highcharts.charts !== undefined) {
        for (var key in Highcharts.charts) {
          if (
            Highcharts.charts[key] !== undefined &&
            Highcharts.charts[key] !== null
          ) {
            Highcharts.charts[key].reflow();
          }
        }
      }

      // This is a global function defined in highcharts-modifiers.js
      // It's a pretty hacky way of doing this, but it's convenient to use it this way here in the Angular app
      //   as well as in the final, non-Angular view
      hideLastColumnGridline();
    }, 1600);
  }

  addWidget(type) {
    // Using this hack to tell the child component to add a widget
    this.$rootScope.$broadcast("share-dashboard__add-widget", { type: type });
  }

  share() {
    this.requestInProgress = true;

    // Just make sure that any drilldowns get closed to avoid an unexpected state in the shared dashboard
    if (
      window.sdrCurrentOpenDrilldownHash !== undefined &&
      window.sdrCurrentOpenDrilldownHash !== null &&
      $(window.sdrCurrentOpenDrilldownHash + " #drilldown-container").length > 0
    ) {
      $(window.sdrCurrentOpenDrilldownHash + " #drilldown-container").fadeOut(
        function () {
          $(
            window.sdrCurrentOpenDrilldownHash + " .drilldown__back-button"
          ).css("display", "none");
          $(
            window.sdrCurrentOpenDrilldownHash + " #drilldown-container"
          ).remove();
          $(window.sdrCurrentOpenDrilldownHash + " .height-container").show();
        }
      );
    }

    this.saveToDynamo();
  }

  saveToDynamo() {
    this.$http
      .put("/aws/dynamoDb/sharableDashboard", this.config)
      .then((dynamoRecord) => {
        if (dynamoRecord.data.id !== null) {
          this.config.id = dynamoRecord.data.id;
          this.config.displayName = dynamoRecord.data.displayName;
          this.config.created = dynamoRecord.data.created;
          this.config.modified = dynamoRecord.data.modified;
          this.isDirty = false;

          var config = {
            method: "POST",
            url:
              "/sharable-dashboard-update/" +
              this.company._id +
              "/" +
              this.config.id,
            data: {
              content: angular
                .element("#sharable-dashboard-editor.sharable-dashboard")
                .html(),
              widgets: this.widgets,
              config: this.config,
              isInitialShare: this.isInitialShare,
            },
          };

          this.saveDashboard(config);
        }
      })
      .catch(function (err) {
        console.log("Unable to save report record to DynamoDB", err);
      });
  }

  saveDashboard(config) {
    console.log("saveDashboard");
    console.log(this.companyId, this.config.companyId);
    this.$http(config)
      .then((res) => {
        this.requestInProgress = false;
        this.config = res.data;
        this.link =
          this.NEW_SHARABLE_DASHBOARD_URL +
          "/sharable_dashboard/" +
          this.config.companyId +
          "/" +
          this.config.id;
        this.origPassword = this.config.password;
        this.isInitialShare =
          this.config.password === undefined ||
          this.config.password === null ||
          this.config.password === "";

        // Now make sure the drilldown partial HTMLs get upgraded from Redis to S3
        // (which can happen as the user looks at the dialog, enters password, etc.)
        this.$http({
          method: "POST",
          url: "/sharable_dashboard_upload_drilldowns",
          data: this.config,
        });

        this.config.password = null;

        if (
          this.config.password === undefined ||
          this.config.password === null ||
          this.config.password.length === 0
        ) {
          this.showPasswordDialog();
        } else {
          this.link =
            this.NEW_SHARABLE_DASHBOARD_URL +
            "/sharable_dashboard/" +
            this.config.companyId +
            "/" +
            this.config.id;
          this.origPassword = this.config.password;

          this.openReportSharePanel();
        }
      })
      .catch(function (err) {
        console.log("error updating report config / saving to s3", err);
      });
  }

  openReportSharePanel() {
    console.log("openReportSharePanel");
    let apiBase = "https://staging.meltwater.net/report/api";
    let loginBaseUri = "https://staging.meltwater.net";

    if (this.isProd) {
      apiBase = "https://app.meltwater.com/report/api";
      loginBaseUri = "https://app.meltwater.com";
    }

    window.reportSharePanelConfig = {
      apiBase,
      loginBaseUri,
    };

    const event = new CustomEvent("mw-report-share-panel-open", {
      detail: {
        password: this.config.password,
        reportUrl:
          this.NEW_SHARABLE_DASHBOARD_URL.replace("http://", "https://") +
          "/sharable_dashboard_viewer/" +
          this.config.companyId +
          "/" +
          this.config.id,
        title: this.config.title,
        id: this.config.id,
        updateApiUrl: "",
        reportType: "Classic",
        dashboardName: this.dashboardName || null,
        dashboardId: this.dashboardId || null,
        parentType: "Classic Dashboard",
      },
    });

    document.dispatchEvent(event);

    document.addEventListener(
      "mw-report-share-panel-updated",
      (e: CustomEvent) => {
        this.password = e.detail.password;
        this.dashboardName = e.detail.title;
        this.updatePass(e.detail.password, e.detail.title);
      }
    );
  }
  updatePass(password: any, title: any) {
    if (password) {
      this.config.password = password;
    }

    if (title) {
      this.config.title = title;
    }

    this.saveConfig(false);
    // throw new Error("Method not implemented.");
  }

  showPasswordDialog() {
    this.$mdDialog
      .show({
        autoWrap: false,
        fullscreen: true,
        bindToController: true,
        skipHide: true,
        multiple: true,
        parent: angular.element(
          document.getElementsByClassName("mw-flexi-modal")[0]
        ),
        template: `
                    <md-dialog id="share-dialog" class="mw-mini-modal" aria-label="" layout="column">
                        <mw-mini-modal-dialog class="mw-mini-modal-dialog" layout="column" data-title="{{'Set dashboard password' | translate}}" ok="{{'Save' | translate}}" on-ok="$ctrl.saveConfig(true);" is-ok-enabled="$ctrl.config.password !== undefined && $ctrl.config.password !== null && $ctrl.config.password.length > 0" cancel="{{'Cancel' | translate}}" on-cancel="$ctrl.$mdDialog.hide();">
                            <mw-modal-content layout="column" ng-form="shareDashboardForm">
                                <mw-loader class="full-screen-loader" ng-show="$ctrl.requestInProgress"></mw-loader>
                                <div flex="100" layout="row">
                                    <md-input-container flex="100">
                                        <label translate>Password</label>
                                        <input ng-model="$ctrl.config.password" name="password" required="true" ng-change="$ctrl.isDirty = ($ctrl.origPassword !== $ctrl.config.password);" />
                                        <div class="md-caption" translate>You need a password before you can share.</div>
                                    </md-input-container>
                                </div>
                            </mw-modal-content>
                        </mw-mini-modal-dialog>
                    </md-dialog>
                `,
        controller: () => this,
        controllerAs: "$ctrl",
      })
      .then(
        function () {},
        function () {}
      );
  }

  showShareDialog() {
    this.$mdDialog
      .show({
        autoWrap: false,
        fullscreen: true,
        bindToController: true,
        skipHide: true,
        multiple: true,
        parent: angular.element(
          document.getElementsByClassName("mw-flexi-modal")[0]
        ),
        onShowing: function () {
          this.$timeout(function () {
            angular.element("#link").select();
          }, 500);
        }.bind(this),
        template: `
            <md-dialog id="share-dialog" class="mw-mini-modal" aria-label="" layout="column">
                <mw-mini-modal-dialog class="mw-mini-modal-dialog" layout="column" data-title="{{'Password and link' | translate}}" ok="{{'OK' | translate}}" on-ok="$ctrl.$mdDialog.hide();" cancel="{{'Cancel' | translate}}" on-cancel="$ctrl.$mdDialog.hide();">
                    <mw-modal-content layout="column" ng-form="shareDashboardForm">
                        <mw-loader class="full-screen-loader" ng-show="$ctrl.requestInProgress"></mw-loader>
                        <div flex="100" layout="column">
                            <md-input-container flex="100">
                                <label translate>Password</label>
                                <input ng-model="$ctrl.config.password" name="password" required="true" ng-change="$ctrl.isDirty = ($ctrl.origPassword !== $ctrl.config.password);" />
                                <div ng-messages="shareDashboardForm.password.$error">
                                    <div ng-message="required" translate="app__form-messaging--required-field"></div>
                                </div>
                                <div class="md-caption" translate>You can change your password any time.</div>
                            </md-input-container>
                            <div ng-if="$ctrl.isDirty === true" flex="100" layout="column" layout-align="start end">
                                <md-button id="share-dialog__save-password__button" class="mw-button mw-button--outlined" ng-click="$ctrl.saveConfig(false);" ng-disabled="$ctrl.config.password === undefined || $ctrl.config.password === null || $ctrl.config.password.length === 0"><span translate>Update<span></md-button>
                            </div>
                        </div>
                        <div class="share-dashboard-dialog__link-container" flex="100" layout="column">
                            <md-input-container id="sharable-dashboard__link-input" flex="100">
                                <label translate>Your dashboard link</label>
                                <input id="link" name="link" ng-model="$ctrl.link" readonly />
                            </md-input-container>
                            <div flex="100" layout="row">
                                <div flex="60" layout="column" layout-align="center start">
                                    <a id="sharable-dashboard__open-link" target="_blank" href="{{$ctrl.link}}" translate>Open in new window</a>
                                </div>
                                <div flex="40" layout="column" layout-align="start end">
                                    <md-button class="mw-button mw-button--outlined" ngclipboard data-clipboard-text="{{$ctrl.link}}" ngclipboard-success="$ctrl.showCopiedTooltip();"><span translate>Copy link</span></md-button>
                                    <div class="share-dashoard-dialog__success-text" flex="100" ng-style="{'visibility': $ctrl.showCopySuccess === true ? 'visible' : 'hidden'}" translate>Copied!</div>
                                </div>
                            </div>
                        </div>
                    </mw-modal-content>
                </mw-mini-modal-dialog>
            </md-dialog>
        `,
        controller: () => this,
        controllerAs: "$ctrl",
      })
      .then(
        function () {},
        function () {}
      );
  }

  showCopiedTooltip() {
    this.showCopySuccess = true;
    this.$timeout(
      function () {
        this.showCopySuccess = false;
      }.bind(this),
      3000
    );
  }

  saveConfig(openNextDialog) {
    if (
      this.config !== undefined &&
      this.config !== null &&
      this.config.password !== undefined &&
      this.config.password !== null &&
      this.config.password !== "null" &&
      this.config.password !== ""
    ) {
      this.requestInProgress = true;

      // Save config to dynamo
      this.$http.put("/aws/dynamoDb/sharableDashboard", this.config);

      // Then save the HTML partial to S3
      var content = angular
        .element("#sharable-dashboard-editor.sharable-dashboard")
        .html();
      // POST updated HTML to generator service to be persisted
      var config = {
        method: "POST",
        url:
          "/sharable-dashboard-update/" +
          this.company._id +
          "/" +
          this.config.id,
        data: {
          content: content,
          widgets: this.widgets,
          config: this.config,
          isInitialShare: this.isInitialShare,
        },
      };
      this.$http(config)
        .then(
          function (res) {
            this.requestInProgress = false;
            this.config = res.data;
            this.link =
              this.NEW_SHARABLE_DASHBOARD_URL +
              "/sharable_dashboard/" +
              this.config.companyId +
              "/" +
              this.config.id;
            this.origPassword = this.config.password;
            delete this.isDirty;
            this.isInitialShare =
              this.config.password === undefined ||
              this.config.password === null ||
              this.config.password === "";
            if (openNextDialog === true) {
              this.$mdDialog.hide();
              this.openReportSharePanel();
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.requestInProgress = false;
          }.bind(this)
        );
    }
  }

  cancelShare(ev) {
    if (this.isDirty === true) {
      var title = this.$translate.instant("Are you sure you want to leave?"),
        content = this.$translate.instant("Your unsaved work will be lost"),
        okLabelAction = this.$translate.instant("OK"),
        cancelLabelAction = this.$translate.instant("Cancel");

      this.$mdDialog
        .show(
          this.$mdDialog
            .mwConfirm()
            .multiple(true)
            .title(title)
            .textContent(content)
            .ok(okLabelAction)
            .cancel(cancelLabelAction)
            .targetEvent(ev)
            .parent(
              angular.element(
                document.getElementsByClassName("mw-flexi-modal")[0]
              )
            )
        )
        .then(
          function okHandler() {
            this.$mdDialog.cancel();
            this.requestInProgress = true;

            if (this.creatingReportFlag) {
              this.$window.location.href =
                this.ANALYZE_WEB_URL +
                "/analyze/dashboard/viewer/" +
                this.dashboardId;
            } else {
              this.$location.path("/sharable-dashboard-manager");
            }
          }.bind(this),
          function cancelHandler() {}
        );
    } else {
      this.requestInProgress = true;
      if (this.creatingReportFlag) {
        this.$window.location.href =
          this.ANALYZE_WEB_URL +
          "/analyze/dashboard/viewer/" +
          this.dashboardId;
      } else {
        this.$location.path("/sharable-dashboard-manager");
      }
    }
  }

  uploadFile($file, coverOrLogo) {
    if ($file !== undefined && $file !== null) {
      this.requestInProgress = true;
      this.Upload.upload({
        url: "/aws/s3/" + this.companyId,
        file: $file,
      })
        .progress(function (e) {})
        .then(
          function (res, status, headers, config) {
            // if(coverOrLogo === 'cover') {
            //     this.reportConfig.cover.uploadedSrc = res.data.url;
            //     this.reportConfig.cover.uploadedName = res.data.name;
            // } else if(coverOrLogo === 'logo') {
            //     this.reportConfig.uploadedBadgeSrc = res.data.url;
            //     this.reportConfig.uploadedBadgeName = res.data.name;
            // }
            angular
              .element("[data-rpt-cover-image]")
              .attr("data-rpt-cover-image", res.data.url);
            this.requestInProgress = false;
          }.bind(this)
        );
    }
  }
}

const sharableDashboardBuilderConfig = {
  name: "mwPrInsightSharableDashboardReportBuilder",
  bindings: {
    dashboardId: "@?",
    generateContent: "<?",
    sharedReportsCount: "<?",
  },
  controller: SharableDashboardBuilderComponent,
  template: `
        <script type="text/ng-template" id="shareDashboardDialogTemplate">
            <md-dialog id="sharable-dashboard-flexi-modal" class="mw-flexi-modal" ng-class="{'share-dashboard__disable-transitions': $ctrl.mwEnvDetector.browser.indexOf('firefox') >= 0}" aria-label="Fleximodal" layout="column">
                <md-toolbar layout="column">
                    <div class="md-toolbar-tools">
                        <md-icon class="mw-navigation__eyecon-glyph md-primary" md-svg-src="icons/meltwater-icons/eyecon-glyph.svg"></md-icon>
                        <h2><span translate>Share Dashboard</span><span> - {{$ctrl.config.title || $ctrl.config.name}}</span></h2>
                        <div flex=""></div>
                        <md-button class="md-icon-button" ng-click="$ctrl.cancelShare($event)">
                            <md-icon md-svg-icon="navigation:ic_close_24px" aria-label="{{'Close dialog' | translate}}"></md-icon>
                        </md-button>
                    </div>
                </md-toolbar>
                <md-dialog-content layout="column" flex layout="column">
                    <mw-loader class="full-screen-loader" ng-show="$ctrl.requestInProgress"></mw-loader>
                    
                    <mw-pr-insight-sharable-dashboard-report-builder-preview 
                        dashboard-id="$ctrl.dashboardId" 
                        generate-content="$ctrl.generateContent" 
                        is-editing="$ctrl.isEditing" 
                        is-dirty="$ctrl.isDirty" 
                        link-config="$ctrl.config" 
                        widgets="$ctrl.widgets" 
                        toast = "$ctrl.toastMessage"
                        creating-report-flag = "$ctrl.creatingReportFlag"
                        content-available = "$ctrl.contentAvailable"
                        show-loading = "$ctrl.showLoading"
                        show-report = "$ctrl.showReport()"
                        share-report = "$ctrl.share()"
                        class="no-scroll">
                    </mw-pr-insight-sharable-dashboard-report-builder-preview>
                </md-dialog-content>
                <md-dialog-actions layout="row">
                    <md-menu class="mw-menu" md-offset="0 -124" ng-if="$ctrl.showLoading !== true" ng-disabled="$ctrl.isEditing === true">
                        <md-button md-no-ink type="button" class="mw-button" ng-click="$mdMenu.open($event)" aria-label="{{'Add slide' | translate}}"><span translate>Add slide</span><md-icon md-svg-icon="navigation:ic_arrow_drop_down_24px" style="color: #34b7bd;"></md-icon></md-button>
                        <md-menu-content id="share-dashboard__add-widget-menu" class="mw-menu-dropdown" md-padding="md-padding">
                            <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                            <mw-menu-item type="singleselect" on-click="$ctrl.addWidget('summary')" is-disabled="$ctrl.widgets !== undefined && $ctrl.widgets.length >= 80"><span translate>Summary</span></mw-menu-item>
                            <mw-menu-item type="singleselect" on-click="$ctrl.addWidget('divider')" is-disabled="$ctrl.widgets !== undefined && $ctrl.widgets.length >= 80"><span translate>Divider</span></mw-menu-item>
                            <mw-menu-item type="singleselect" on-click="$ctrl.addWidget('conclusion')" is-disabled="$ctrl.widgets !== undefined && $ctrl.widgets.length >= 80"><span translate>Conclusion</span></mw-menu-item>
                        </md-menu-content>
                    </md-menu>
                    <div flex></div>
                    <md-button class="mw-button md-primary" ng-if="$ctrl.showLoading !== true" ng-disabled="$ctrl.isEditing === true || $ctrl.requestInProgress === true" ng-click="$ctrl.share()" aria-label="{{'Share' | translate}}"><span translate>Share</span></md-button>
                </md-dialog-actions>
            </md-dialog>
            <mw-report-share-panel-on-open></mw-report-share-panel-on-open>
        </script>
    `,
};

export {
  sharableDashboardBuilderConfig,
  SharableDashboardBuilderComponent as default,
};
